import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function RecommitObedience() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Recommit yourself to full obedience and service to God" />
        <blockquote>
          “If you love Me, you will keep My commandments.” (John 14:15)
        </blockquote>

        <p>Once we have rededicated ourselves to God and are filled with His Spirit, we are now ready to commit ourselves fully to God’s work. Engaging in the Lord’s work gives us a focus and purpose beyond ourselves that lifts us above our circumstances. It takes our eyes off of our own needs and interests, and it helps quench those breeding grounds for sin: self-centeredness, laziness, and worldly interests. The more engaged we are in doing meaningful work for the Lord, not only will we be accruing for ourselves reward in heaven and building God’s kingdom on earth, we will have less time to engage in activities that might lead to sin. Having preached and ministered to others, we should be even more concerned for the reputation of the Lord and should not want to dishonor Him (1 Corinthians 9:27). But let us make sure we are serving in the Spirit, paying close attention to daily renewing our minds in the word and abiding in Christ; serving the Lord in the flesh can result in arguments and strife, and that certainly is not needed in the church. Doing what we are called to be doing, for the right motives and by the power of the Spirit, is yet one more way in which we can gain daily victory over temptation.</p>
        <br />

        <ul>
          <li>
            <strong>Purpose to bear much fruit and glorify the Father.</strong><br />
            <em>Mark 4:20, John 15:8, Colossians 1:10</em>
          </li>
          <br />
          <li>
            <strong>Purpose to share the gospel with the lost.</strong><br />
            <em>Proverbs 3:6, 11:30, Ephesians 6:15, Colossians 4:3-6, 1 Peter 3:15-16</em>
          </li>
          <br />
          <li>
            <strong>Purpose to serve, not be served.</strong><br />
            <em>Matthew 20:25-28, Mark 10:45, Hebrews 10:24-25</em>
          </li>
          <br />
          <li>
            <strong>Be a doer of the Word, not a hearer only.</strong><br />
            <em>Matthew 7:24-27, James 1:22-25, 1 John 2:4-6, 3:18</em>
          </li>
          <br />
          <li>
            <strong>Deny yourself, die to self, and take up your cross daily.</strong><br />
            <em>Mark 8:34-38, John 12:24-26, Galatians 2:20</em>
          </li>
          <br />
          <li>
            <strong>Redeem the time; number your days.</strong><br />
            <em>Psalm 90:12, Ephesians 5:15-17</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
